module.exports = __webpack_public_path__ + "static/media/Logo.63e779c6.svg";